<div [formGroup]="payerFormGroup">
  <div class="col-12 md:col-12" style="margin-bottom:-12px; padding-bottom:0px;">
    <h4 class="primColor">{{ 'PAYER' | translate }}</h4>
  </div>

  <div class="field grid">
    <div class="col-12 m-2">
      <p-selectButton [options]="payerTypeOptions" formControlName="payerTypeControl" optionLabel="label" optionValue="value"> </p-selectButton>
    </div>
  </div>

  <div
       class="p-fluid p-formgrid grid gap-1" *ngIf="payerFormGroup.controls.paymentChoiceControl.enabled">
    <div class="col-6 md:col-6" *ngIf="payers?.length">
      <p-dropdown [options]="payers" formControlName="paymentChoiceControl" inputId="payment" optionLabel="name" placeholder="Vælg betaler" [emptyMessage]="'NORESULTS' | translate"> </p-dropdown>
    </div>
  </div>
  <hr />
  <span style="font-size:small;" *ngIf="payerFormInvalid"> {{ 'PAYERREQUIRED' | translate }} </span>
  <div class="bottomBar">
    <button pButton pRipple type="button" label="{{ 'GENERIC.PREVIOUS' | translate }}" *ngIf="stepperService.activeIndex > 0" (click)="stepperService.stepPrev()"> </button>
    <button pButton pRipple type="button" [disabled]="payerFormInvalid" label="{{ 'GENERIC.NEXT' | translate }}" (click)="stepperService.stepNext()"> </button>
  </div>
</div>